import React, { PropsWithChildren, useEffect, useRef } from "react";

type ModalProps = PropsWithChildren & {
    open: boolean;
};

export const Modal = (props: ModalProps) => {
    const dialogRef = useRef(null);

    useEffect(() => {
        if (props.open) {
            dialogRef.current?.showModal();
        } else {
            dialogRef.current?.close();
        }
    }, [props.open]);

    return (
        <dialog className={"overlay"} ref={dialogRef}>
            {props.children}
        </dialog>
    );
};
